import './common'
import 'leaflet'
import "../scss/vendor/leaflet.css"
import Papa from 'papaparse'

/**
 * Geo CSV code, used by the CSV tool
 */
/* global L: false */
(function () {
    var $geocsv = $("#geocsv");
    if ($geocsv.length === 0) {
        return;
    }

    var previewLimit = 10;
    $("#maprow").hide();

    // initialize the map
    const map = L.map('map').setView([40.765396, -73.975954], 18, {animate: true});
    L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    let markerGroup = L.layerGroup().addTo(map);


    var colTypes = {
        "ignore": "Ignore",
        "address": "Address line",
        "street": "Street only",
        "houseNumber": "House number",
        "subNumber": "Subnumber",
        "zipcode": "Zipcode",
        "city": "City",
        "state": "State",
        "country": "Country",
        "ip": "IP Address",
        "phone": "Phone number"
    };

    var colCount = 0;
    var currentFile = null;
    var currentFileHasHeader = false;
    var currentPapaConfig = null;
    var sampleLines = [];
    var processedSample = false;
    var uiBlocked = false;

    function showModal(message, isHTML) {
        if(isHTML) {
            $("#alert-desc").html(message);
        } else {
            $("#alert-desc").text(message);
        }
        $("#alertmodal").modal();
    };

    $geocsv.submit(function (e) {
        e.preventDefault();
        if(uiBlocked) {
            return;
        }
        processedSample = false;
        //$("#geocode-upload-button").removeClass("d-none").addClass("d-none");
        //$("#maprow").hide();

        var files = $geocsv.find("input[name=csvfile]").get(0).files;
        if (!files) {
            alert("Your browser does not support HTML5 file uploads.");
            return;
        }
        var file = files[0];
        if (!file) {
            showModal("Please select a CSV file first.");
            return;
        }

        currentFile = file;
        $("#csv-info").text("Selected file: " + file.name + ", " + file.size + " bytes, showing max " + previewLimit + " lines:");
        $("#csvprocess").text("1. Reload file");
        renderPreview(file);
    });

    // Button handler for the sample geocode button
    $("#geocode-sample-button").click(function (ev) {
        ev.preventDefault();
        if(uiBlocked) {
            return;
        }

        // First run all basic data integrity checks
        var colOrder = [];
        var activeCols = [];
        var colTypeMap = {};

        if (colCount == 0) {
            showModal("Choose a file and press Process first, then map the columns.");
            return;
        }

        for (var i = 0; i < colCount; i++) {
            var colType = $("#col-type-" + i).val();
            activeCols[i] = colType != "ignore";
            if (activeCols[i]) {
                if (colTypeMap[colType]) {
                    showModal("The column data type " + colTypes[colType] + " can't be mapped to more than one column.");
                    return;
                }
                colTypeMap[colType] = true;
                colOrder.push(colType);
            }
        }

        if (colOrder.length == 0) {
            showModal("Please pick the column mapping per column, to indicate what type of data each column holds");
            return;
        }

        // Convert the CSV file lines into lines that can be sent in for sample processing - removing excess columns
        var lines = [];
        for (var i = 0; i < sampleLines.length; i++) {
            var line = [];
            for (var j = 0; j < colCount; j++) {
                if (activeCols[j]) {
                    if (sampleLines[i][j]) {
                        line.push(sampleLines[i][j].replace(/\t/g, ' '));
                    } else {
                        line.push("");
                    }
                }
            }
            lines.push(line);
        }

        var request = {
            "columnOrder": colOrder,
            "sampleLines": lines
        };

        geocodeSample(request);
    });

    // Get the col order or activeCols. Iff returnColOrder is true, returns a list with the columns,
    // iff false will return an array of booleans per input col
    function getColOrder(returnColOrder) {
        // First run all basic data integrity checks
        var colOrder = [];
        var activeCols = [];
        var colTypeMap = {};

        if (colCount == 0) {
            return [];
        }

        for (var i = 0; i < colCount; i++) {
            var colType = $("#col-type-" + i).val();
            activeCols[i] = colType != "ignore";
            if (activeCols[i]) {
                if (colTypeMap[colType]) {
                    return [];
                }
                colTypeMap[colType] = true;
                colOrder.push(colType);
            }
        }

        if (colOrder.length == 0) {
            return [];
        }
        return returnColOrder ? colOrder : activeCols;
    }

    $("#geocode-upload-button").click(function (ev) {
        ev.preventDefault();
        if(uiBlocked) {
            return;
        }
        if (!processedSample) {
            showModal("Please run a successful sample before uploading!");
            return;
        }

        blockUI("upload");

        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: "/account/upload/create",
            data: JSON.stringify({
                filename: currentFile.name,
                columnOrder: getColOrder(true)
            }),
            success: function (response) {
                if (response.success) {
                    var uploadId = response.uploadId;
                    uploadChunks(uploadId);// This method will unblock the UI once it's done
                } else {
                    releaseUI();
                    showModal("Unexpected error during upload!");
                }
            },
            error: function (err, brr, hrr) {
                releaseUI();
                if(err.status == 401) {
                    showModal("You are not logged in! Please sign up or log in to upload CSV files.");
                } else {
                    showModal("Upload error: " + hrr);
                }
            },
            dataType: "json"
        });
    });

    // Upload a chunk of data to an uploadId and call the handler afterwards.
    // The handler will be called with 1 arg: success (boolean)
    function uploadChunk(uploadId, data, partNumber, handler) {
        $.ajax({
            type: "POST",
            contentType: "application/text; charset=utf-8",
            url: "/account/upload/add/" + uploadId + "/" + partNumber,
            data: data,
            success: function (response) {
                handler(response && response.success);
            },
            error: function (err, brr, hrr) {
                handler(false, err && err.responseJSON ? err.responseJSON.errorMessage : null);
            },
            dataType: "json"
        });
    };

    // Remove an upload object from the server.
    function removeUpload(uploadId) {
        $.ajax({
            type: "POST",
            url: "/account/upload/delete",
            data: {
                uploadId: uploadId
            },
            success: function (response) {

            },
            error: function (err, brr, hrr) {

            },
            dataType: "json"
        });
    }

    // Upload all input file data as chunks, with the provided uploadId
    function uploadChunks(uploadId) {
        var activeCols = getColOrder(false);
        var config = currentPapaConfig;
        config.preview = 0;// Make sure we don't cap the amount of lines
        //NOTE: Can't set worker to true, or pausing won't work correctly

        var totalLines = 0;
        var bufferLength = 0;
        var bufferLines = [];
        var maxLines = 10000;
        var maxBytes = 1000000;
        var errorsDetected = false;
        var partNumber = 0;
        var processedFirst = false;

        var flushBuffer = function (parser) {
            if (parser != null) {
                parser.pause();// Pause local iteration until the chunk is done
            }
            if (parser == null && (bufferLines.length == 0 || (bufferLines.length > 0 && bufferLines.join("\n").length == 0))) {// If this is the last flushBuffer call, and we don't have to flush anything, immediately finalize the upload
                finalizeUpload(uploadId, totalLines);
            } else {

                partNumber++;// First part number will be 1

                uploadChunk(uploadId, bufferLines.join("\n"), partNumber, function (success, errorMessage) {
                    if (!success) {
                        errorsDetected = true;
                        releaseUI();
                        showModal(errorMessage ? ("Upload error: " + errorMessage) : "Unknown upload error.");
                        if (parser != null) {
                            parser.abort();
                        }
                        removeUpload(uploadId);
                    } else {
                        $("#csv-info").text("Uploaded " + totalLines + " lines");
                        if (parser != null) {
                            parser.resume();// Continue parsing the rest of the file
                        } else {// The remainder has been flushed, so finalize the file
                            finalizeUpload(uploadId, totalLines);
                        }
                    }
                });
            }

            totalLines += bufferLines.length;
            bufferLength = 0;
            bufferLines = [];
        };

        config.step = function (results, parser) {
            if (!processedFirst && currentFileHasHeader) {
                processedFirst = true;
                return;// Skip this first line, as it's the original header
            }
            processedFirst = true;
            var line = buildLine(activeCols, results.data);
            if (bufferLines.length + 1 > maxLines || bufferLength + line.length + 1 > maxBytes) {
                flushBuffer(parser);
            }

            bufferLines.push(line);
            bufferLength += line.length + 1;// adding 1 position for the linebreak
        };
        config.complete = function (results, file) {
            if (!errorsDetected) {
                flushBuffer(null);
            }
        };
        config.error = function (error, file) {
            releaseUI();
            showModal("Could not read the specified file");
        };
        Papa.parse(currentFile, config);
    };

    // Finalize an upload object, indicating we are done sending chunks
    function finalizeUpload(uploadId, totalLines) {
        $.ajax({
            type: "GET",
            url: "/account/upload/finish/" + uploadId,
            success: function (response) {
                releaseUI();
                // Make sure to redirect on close
                $("#alertmodal").on('hide.bs.modal', function (e) {
                    window.location.href = "/account";
                });

                showModal("Upload complete, uploaded " + totalLines + " lines.<br><br>" +
                    "You can see the status on your <a href='/account'>account</a> page and you'll receive an email when the file is ready.<br><br>" +
                    "Please download the results within 30 days.", true);
            },
            error: function (err, brr, hrr) {
                releaseUI();
                var errorMessage = err && err.responseJSON ? err.responseJSON.errorMessage : "";
                showModal("The upload could not be finalized. " + errorMessage);
                removeUpload(uploadId);
            },
            dataType: "json"
        });
    };

    // Build a tab separated line from an input line, only including the active columns
    function buildLine(activeCols, inputLine) {
        var line = [];
        for (var j = 0; j < inputLine.length; j++) {
            if (activeCols[j]) {
                if (inputLine.length > j) {
                    var value = inputLine[j].replace(/\t/g, ' ');
                    line.push(value);
                } else {
                    line.push("");
                }
            }
        }
        return line.join("\t");
    };

    // Geocode a sample, with the specified request being an object with the column order and sample lines to send in
    function geocodeSample(request) {
        blockUI("sample");
        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: "/csv/sample",
            data: JSON.stringify(request),
            success: function (response) {
                releaseUI();
                if (!response.success) {
                    showModal("The sample geocoding request failed, please fix the input data or try again later.");
                    return;
                }
                var results = response.data.split("\n");

                var minLat = 90;
                var maxLat = -90;
                var minLon = 180;
                var maxLon = -180;
                var latBuffer = 0.001;
                var lonBuffer = 0.001;
                var pins = 0;

                markerGroup.remove();
                markerGroup = L.layerGroup().addTo(map);

                for (var i = 0; i < results.length; i++) {
                    var line = results[i].split("\t");
                    var result = "Not found";
                    var found = false;
                    if (line[0] * 1 != 0 && line[1] * 1 != 0) {
                        var lat = line[0] * 1;
                        var lon = line[1] * 1;
                        minLat = Math.min(minLat, lat - latBuffer);
                        maxLat = Math.max(maxLat, lat + latBuffer);
                        minLon = Math.min(minLon, lon - lonBuffer);
                        maxLon = Math.max(maxLon, lon + lonBuffer);
                        var description = "CSV Line #" + i + "<br>";
                        for (var j = 0; j < request.columnOrder.length; j++) {
                            description += colTypes[request.columnOrder[j]] + ": " + request.sampleLines[i][j] + "<br>";
                        }
                        description += "Accuracy type: " + line[2];

                        var marker = renderMapPin(description, lat, lon);
                        pins++;
                        found = true;
                        result = line[2].charAt(0).toUpperCase() + line[2].slice(1);
                    }
                    $("#csv-status-" + i).text(result);
                    $("#csv-status-" + i).parent("tr").removeClass().addClass(found ? "table-success" : "table-danger");
                }

                if (pins > 0) {
                    processedSample = true;

                    $("#geocode-upload-button").removeClass("d-none");
                    $("#maprow").show();
                    map.invalidateSize();

                    map.fitBounds([[minLat, minLon], [maxLat, maxLon]], {animate: true});

                    showModal("Please review your selected column mapping and the sample results.<br><br>Does everything look good? Press the <b>Upload and Process</b> button to start uploading and processing the entire file.", true);
                } else {
                    showModal("None of the sample rows could be geocoded!<br><br>You must have at least 1 line that can be geocoded in the sample before you can proceed with the entire file.<br><br>Please review the selected column mapping and press the <b>Geocode Sample</b> button again.", true);
                }

            },
            error: function (err, brr, hrr) {
                releaseUI();
                showModal("Error: " + hrr);
            },
            dataType: "json"
        });
    }

    // Add a map pin to the preview map
    function renderMapPin(description, lat, long) {
        let iconUrl = $geocsv.find(".geolake .mapicon").attr("src");
        if (!iconUrl) {
            iconUrl = "/assets/images/leaflet/pin_green.svg";
        }
        const icon = L.icon({
            iconUrl: iconUrl,
            iconSize: [40, 50],
            iconAnchor: [17, 50],
            popupAnchor: [0, -48]
        });
        const marker = L.marker([lat, long], {"icon": icon});
        marker.addTo(markerGroup);
        marker.bindPopup(description);
        return marker;
    }

    // Get the papa config to use
    function getPapaConfig() {
        var delimiter = "";
        var quoteChar = '"';
        var escapeChar = '"';

        if ($("#csvdelim").val() == "comma") {
            delimiter = ",";
        } else if ($("#csvdelim").val() == "semicolon") {
            delimiter = ";";
        } else if ($("#csvdelim").val() == "tab") {
            delimiter = "\t";
        }

        if ($("#csvescape").val() == "doublequoteslash") {
            escapeChar = "\\";
        }

        return {
            delimiter: delimiter,
            quoteChar: quoteChar,
            escapeChar: escapeChar,
            header: false
        };
    }

    // Render the preview area once the first few lines have been extracted
    function renderPreview(file) {
        var hasHeader = false;

        if ($("#csvheader").val() == "yes") {
            hasHeader = true;
        }

        var config = getPapaConfig();
        config.preview = previewLimit + (hasHeader ? 1 : 0);
        config.complete = function (results, f) {
            renderPreviewResult(results, f, hasHeader);
        };
        currentPapaConfig = config;// Save this config for actual upload processing, to ensure updated inputs don't change the outcome
        currentFileHasHeader = hasHeader;

        Papa.parse(file, config);
    };

    function renderPreviewResult(results, f, hasHeader) {
        if (results.meta.aborted || results.data.length == 0) {
            showModal("Could not read any lines from the CSV file!");
            return;
        }

        colCount = results.data[0].length;
        var table = $("<table>").addClass("table");
        var thead = $("<thead>");
        table.append(thead);
        var theadtr = $("<tr>");
        thead.append(theadtr);
        for (var i = 0; i < colCount; i++) {
            var colName = hasHeader ? escapeHtml(results.data[0][i]) : ("Column #" + i);
            var col = $("<th>").html(colName + "<br>" + buildColSelect("col-type-" + i));
            theadtr.append(col);
        }
        var statusCol = $("<th>").html("Result\nAccuracy");
        theadtr.append(statusCol);
        var tbody = $("<tbody>");
        table.append(tbody);

        sampleLines = [];// Reset the shared sampleLines array
        var firstRow = hasHeader ? 1 : 0;
        for (var i = firstRow; i < results.data.length; i++) {
            var rowIndex = hasHeader ? (i - 1) : i;
            var line = results.data[i];
            if (line.length <= 1 && !line[0] && i == results.data.length - 1) {
                break;// This was an empty last line
            }
            sampleLines.push(line);
            var tr = $("<tr>");
            tbody.append(tr);
            // Add a cell for each column
            for (var j = 0; j < line.length; j++) {
                var td = $("<td>").text(line[j]);
                tr.append(td);
            }

            // Add a cell for the status column
            tr.append($("<td>").attr("id", "csv-status-" + rowIndex));
        }

        $("#csv-picker").empty().append(table);
        $("#geocode-sample-button").removeClass("d-none");
        showModal("Please select the type of data in each column and press <b>Geocode Sample</b> to confirm the results.", true);
    };

    // Build the HTML for a column data type dropdown
    function buildColSelect(selectId) {
        var html = "<select id='" + selectId + "' class='csv-col-selector'>";
        for (const key in colTypes) {
            if (colTypes.hasOwnProperty(key)) {
                html += "<option value='" + key + "'>" + colTypes[key] + "</option>";
            }
        }
        html += "</select>";
        return html;
    }

    // Escape HTML, allowing unsafe input to be shown inside a generated HTML block
    function escapeHtml(unsafe) {
        return unsafe
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function blockUI(spinnerButton) {
        uiBlocked = true;
        $("#csvprocess").addClass("disabled");
        var sampleBtn = $("#geocode-sample-button")
            .prop("disabled", true);
        if(spinnerButton == "sample") {
            sampleBtn.find(".spinner-disabled").removeClass("spinner-disabled");
        }
        var uploadBtn = $("#geocode-upload-button")
            .prop("disabled", true);
        if(spinnerButton == "upload") {
            uploadBtn.find(".spinner-disabled").removeClass("spinner-disabled");
        }
    };

    function releaseUI() {
        uiBlocked = false;
        $("#csvprocess").removeClass("disabled");
        $("#geocode-sample-button")
            .prop("disabled", false)
            .find("span:not(.spinner-disabled)").addClass("spinner-disabled");
        $("#geocode-upload-button")
            .prop("disabled", false)
            .find("span:not(.spinner-disabled)").addClass("spinner-disabled");
    };

})();